/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';

import { usePrintsOrderStore } from '../stores';
import { useSizesWithPhotos } from '../hooks/use-sizes-with-photos';
import { selectHasUnsavedChanges } from '../stores/selectors';

const preStyle = {
  backgroundColor: '#f5f5f5',
  border: '1px solid #ccc',
  padding: '10px',
  margin: '10px 0',
  whiteSpace: 'pre-wrap',
  wordWrap: 'break-word',
  cursor: 'pointer',
};

const handleSelect = (event) => {
  const range = document.createRange();
  range.selectNodeContents(event.currentTarget);
  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
};

const DebugBox = ({ data }) => {
  return (
    <pre style={preStyle} onClick={handleSelect}>
      {JSON.stringify(data, null, 2)}
    </pre>
  );
};

DebugBox.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};

export default function DebugView() {
  // --- SELECTORS ---
  const hasUnsavedChanges = usePrintsOrderStore(selectHasUnsavedChanges);

  // --- HOOKS ---
  const sizesByFinish = useSizesWithPhotos();

  // --- RENDER ---
  const photo_state = sizesByFinish.reduce(
    (acc, s) => {
      if (!s.photos.length) return acc;

      acc[s.key] = s.photos;

      return acc;
    },
    { hasUnsavedChanges },
  );

  return (
    <div style={{ padding: '10px' }}>
      <h4>Photo State</h4>
      <DebugBox data={photo_state} />
    </div>
  );
}
